<button
  mat-icon-button
  (click)="onMenuToggle()"
  class="sp-icon__button sp-icon__button-accent sp-margin__left">
  <mat-icon> sort </mat-icon>
</button>

<div
  *ngIf="is_menu_visible"
  [@slideInOut]
  class="sp-menu__toolbar-mobile sp-width__full sp-position__absolute sp-background__accent">
  <div class="sp-row__space sp-width__full sp-toolbar__height sp-padding__horiz-x2">
    <img
      src="../../../assets/img/logo/sp-logo-light.svg"
      class="sp-logo__m" />

    <button
      (click)="onMenuToggle()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-light">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div
    id="sp-menu__toolbar-mobile-items"
    class="sp-padding__x4 sp-margin__top-x4 sp-margin__bottom-x2 sp-overflow__y-scroll">
    <div
      *ngFor="let item of getNavItems()"
      (click)="onNavItemClick(item)"
      class="sp-cursor__pointer sp-row__end sp-margin__bottom">
      <div
        [ngClass]="getCurrentItemClass(item)"
        class="sp-width__fit-content">
        <h3 class="sp-margin__left">
          {{ item.label || '' | translate }}
        </h3>
      </div>
    </div>
  </div>
</div>
